import { ISliderConf } from '@notino/react-styleguide';

export const THUMBS_SLIDER_CONFIG: ISliderConf = {
  slidesToShow: 10,
  slidesToScroll: 10,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 8,
        slidesToScroll: 8,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6,
      },
    },
  ],
};
